module.exports = __webpack_public_path__ + "img/qr-code.591e6ed5.png";